import React, { createContext, useState, useContext, ReactNode } from "react";

interface CreditsContextProps {
  credits: number;
  setCredits: (value: number) => void;
}

const CreditsContext = createContext<CreditsContextProps | undefined>(
  undefined
);

export const CreditsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [credits, setCredits] = useState(0);

  return (
    <CreditsContext.Provider value={{ credits, setCredits }}>
      {children}
    </CreditsContext.Provider>
  );
};

export const useCredits = () => {
  const context = useContext(CreditsContext);
  if (!context) {
    throw new Error("useCredits must be used within a CreditsProvider");
  }
  return context;
};
